<template>
  <base-wrapper>
    <edit-office-form
      office-type="member"
      :office-id="$route.params.id"
      :disabled-fields="['code']"
      @success="$router.push({ name: 'master-mitra-usaha' })"
    />
  </base-wrapper>
</template>
<script>
import EditOfficeForm from '@/components/office/edit-office-form.vue';

export default {
  name: 'EditStockist',
  components: {
    EditOfficeForm,
  },
};
</script>
